import React from 'react';
import { Card, CloseButton, Modal } from 'react-bootstrap';
import usePayment from './usePayment';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import SimpleBarReact from 'simplebar-react';
import IconButton from 'components/common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
/* import { Link } from 'react-router-dom'; */
/* import SoftBadge from 'components/common/SoftBadge'; */
import { currency } from 'helpers/utils';

const QueryPayment = () => {
 const { show, handleClose, onError, watch, register, handleSubmit, errors, consultContractsByDoc, contracts, setcontract } =
  usePayment();

 return (
  <Modal show={show} onHide={handleClose} className="mt-4">
   <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
    <div className="position-relative z-index-1 light">
     <h4 className="mb-0 text-white" id="authentication-modal-label">
      Register
     </h4>
     <p className="fs--1 mb-0 text-white">Please create your free Falcon account</p>
    </div>
    <CloseButton variant="white" className="position-absolute end-0 me-2 mt-2 top-0" onClick={handleClose} />
   </Modal.Header>
   <Modal.Body className="p-4">
    <Flex className="fs--2 mt-2 mt-sm-0" alignItems="center" wrap="nowrap">
     <Input
      type="select"
      name="docType"
      placeholder="Documento"
      errors={errors}
      formGroupProps={{ className: 'me-2' }}
      options={[
       { label: 'C. Ciudadanía', value: 'CC' },
       { label: 'C. Extranjera', value: 'CE' },
       { label: 'Pasaporte', value: 'PP' },
       { label: 'Nit', value: 'NIT' },
       { label: 'Permiso Especial', value: 'PEP' },
       { label: 'C. Venezolana', value: 'CCVE' }
      ]}
      formControlProps={{ ...register('docType', { required: true }), size: 'sm' }}
     />
     <Input
      type="text"
      name="docNumber"
      errors={errors}
      formGroupProps={{ className: 'me-2' }}
      formControlProps={{ ...register('docNumber', { required: true }), size: 'sm', onFocus: ({ target }) => target.select() }}
     />

     <IconButton
      icon="search"
      className="m-0 fs--1 me-0"
      classText="d-none d-sm-block"
      transform="shrink-2"
      size="sm"
      variant="falcon-default"
      onClick={() => handleSubmit(consultContractsByDoc, onError)()}
      disabled={!watch('docType') || !watch('docNumber')}
     >
      Buscar
     </IconButton>
    </Flex>

    {contracts?.length ? (
     contracts?.map((contract, index) => (
      <SimpleBarReact key={index} style={{ maxHeight: 150 }} className="p-3 mt-3">
       <Card className="mb-2">
        <Card.Body className="cursor-pointer" onClick={() => setcontract(contract)}>
         <Flex justifyContent="start" alignItems="center" wrap="wrap">
          <Avatar size="2xl" src={contract?.project?.logo} name={contract?.project?.name} className="me-1" />
          <div className="flex-grow-1 text-truncate">
           <h5 className="mb-0 fs--1 text-capitalize text-primary">
            {contract?.project?.detail
             ? contract?.project?.detail
             : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4)}
           </h5>
           <h4 className="m-0 fs--1 text-capitalize">Detalle del producto</h4>
          </div>
          <div className="d-flex justify-content-center justify-content-md-end align-items-center flex-nowrap flex-grow-1 mt-4 mt-md-0">
           <div className="px-3 border-start border-start-2">
            <h5 className="mb-0 fs--1 ">{currency(contract?.owed, true)}</h5>
            <p className="mb-0 fs--2 text-center">
             {new Date(contract?.start).toLocaleString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false // Establece en false para usar formato de 24 horas
             })}
            </p>
           </div>
          </div>
         </Flex>
        </Card.Body>
       </Card>
      </SimpleBarReact>
     ))
    ) : (
     <Card className="bg-transparent shadow-none py-3">
      <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
       <div className="fs--1">
        <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
        <h5>¡No se han encontrado Ordenes!</h5>
        <p className="mb-0">Su búsqueda no coincidió con ningúna orden. Verifica el documento y vuelve a intentar</p>
       </div>
      </Card.Body>
     </Card>
    )}
   </Modal.Body>
  </Modal>
 );
};

export default QueryPayment;
